export const UNDO_TIMEER_LIMIT: number = 4000;
export const MAX_SEARCH_HISTORY_PRESERVED: number = 8;
export const ALLOW_VIDEO_TYPE = [
    'MP4',
    'WEBM',
    'MOV'
];